/* eslint jsx-a11y/click-events-have-key-events: 0,jsx-a11y/no-static-element-interactions: 0 */

import React from 'react';

import { FormattedMessageWrapper } from '@goeuro/app/client/fe-utils/src/localization/FormattedMessageStopgap/FormattedMessageWrapper';
import AuthMenu from '@goeuro/app/client/user-profile-components/src/containers/AuthMenu';
import HeaderComponent from '@goeuro/app/client/b2b-components/src/components/smart-header/SmartHeader';
import LargeModal from '@goeuro/app/client/frontend-components/src/Modals/LargeModal';
import NavigationItem from '@goeuro/app/client/frontend-components/src/NavigationItem';
import { Close } from '@goeuro/app/client/frontend-components/src/Icons2/Close';
import { ExternalLink } from '@goeuro/app/client/frontend-components/src/Icons2/ExternalLink';
import { Currency } from '@goeuro/app/client/frontend-components/src/Icons2/Currency';
import { Chat } from '@goeuro/app/client/frontend-components/src/Icons2/Chat';
import {
  locales,
  defaultLocale,
  localeToFlagSrc,
  Locale as LocaleItem,
} from 'constants/locales';
import {
  currencies,
  Currency as CurrencyItem,
  defaultCurrency,
} from 'constants/currencies';
import MobileHeaderMenu from './MobileHeaderMenu';
import {
  MobileHeaderProps,
  MobileHeaderModalProps,
  Option,
} from './MobileHeader.props';
import * as Styled from './MobileHeaderModal.styled';

const getOptions = (
  options: LocaleItem[] | CurrencyItem[],
  value: string
): Option[] =>
  options.map(option => {
    if ('symbol' in option) {
      return {
        key: option.code,
        label: option.code,
        symbol: option.symbol,
        selected: option.code === value,
      };
    }

    return {
      key: option.code,
      label: option.label,
      iconSrc: localeToFlagSrc(option.code),
      selected: option.code === value,
    };
  });

const ModalHeader = ({ onClose, locale, currency }: MobileHeaderProps) => {
  return (
    <>
      {/* @ts-ignore */}
      <HeaderComponent locale={locale} currency={currency}>
        <Close width={24} height={24} onClick={onClose} />
      </HeaderComponent>
    </>
  );
};

const MobileHeaderModal = ({
  onClose,
  lang,
  wlData,
  currency,
  setLang,
  setCurrency,
  showCurrencySwitcher,
  showModal,
}: MobileHeaderModalProps) => {
  const [isCurrencyMenu, setIsCurrencyMenu] = React.useState(false);
  const [isLangMenu, setIsLangMenu] = React.useState(false);

  const backButtonPress = () => {
    window.location.href = wlData.backButtonLink;
  };

  const enabledLocales = wlData?.enabledLocales || [];
  const filteredLocales =
    enabledLocales.length > 0
      ? locales.filter(({ code }) => enabledLocales.includes(code))
      : locales;

  const selectedLocale =
    filteredLocales.find(({ code }) => code === lang) ||
    filteredLocales[0] ||
    defaultLocale;

  const enabledCurrencies = wlData?.enabledCurrencies || [];
  const filteredCurrencies =
    enabledCurrencies.length > 0
      ? currencies.filter(({ code }) => enabledCurrencies.includes(code))
      : currencies;

  const selectedCurrency =
    filteredCurrencies.find(curr => curr.code === currency) ||
    filteredCurrencies[0] ||
    defaultCurrency;

  const toggleCurrencyMenu = () => setIsCurrencyMenu(!isCurrencyMenu);
  const toggleLangMenu = () => setIsLangMenu(!isLangMenu);

  const onCurrencyChange = newCurrency => {
    setCurrency(newCurrency);
    toggleCurrencyMenu();
    onClose();
  };

  const onLangChange = newLang => {
    setLang(newLang);
    toggleLangMenu();
    onClose();
  };

  const commonIconProps = {
    width: 24,
    height: 24,
    style: { marginRight: '8px' },
  };

  return (
    <LargeModal
      visible={showModal}
      header={
        <ModalHeader onClose={onClose} locale={lang} currency={currency} />
      }
      onClose={onClose}
      fullWidth
    >
      <Styled.ModalBody>
        {wlData.backButtonLabel && wlData.backButtonLink && (
          <NavigationItem
            icon={<ExternalLink {...commonIconProps} />}
            label={wlData.backButtonLabel}
            onPress={backButtonPress}
          />
        )}
        {showCurrencySwitcher && (
          <>
            <NavigationItem
              icon={<Currency {...commonIconProps} />}
              label={<FormattedMessageWrapper translationId="seo.currency" />}
              valueContent={selectedCurrency.code}
              onPress={toggleCurrencyMenu}
              withChevron
            />
            <MobileHeaderMenu
              title={<FormattedMessageWrapper translationId="seo.currency" />}
              showModal={isCurrencyMenu}
              toggle={toggleCurrencyMenu}
              options={getOptions(filteredCurrencies, selectedCurrency.code)}
              onChange={onCurrencyChange}
            />
          </>
        )}
        <NavigationItem
          icon={<Chat {...commonIconProps} />}
          label={<FormattedMessageWrapper translationId="seo.language" />}
          valueContent={
            <img
              src={localeToFlagSrc(selectedLocale.code)}
              width={25}
              height={18}
              alt={selectedLocale.label}
            />
          }
          onPress={toggleLangMenu}
          withChevron
        />
        <MobileHeaderMenu
          title={<FormattedMessageWrapper translationId="seo.language" />}
          showModal={isLangMenu}
          toggle={toggleLangMenu}
          options={getOptions(filteredLocales, selectedLocale.code)}
          onChange={onLangChange}
        />
        {wlData.enableUserProfile && (
          <Styled.AuthWrapper>
            <AuthMenu />
          </Styled.AuthWrapper>
        )}
      </Styled.ModalBody>
    </LargeModal>
  );
};

export default MobileHeaderModal;
